export const  HolidayNameColumns = [
    "SNo",
    "HolidayName",
    "HolidayDate"
    
   
];
